import QueryRoutes from "./query";
import ReportingRoutes from "./reporting";

export default [
    ...QueryRoutes,
    ...ReportingRoutes
];
